// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main_content":"main_content-1NShSNos","end":"end-1LHZzB5z"};